const CLOSED = 'closed';
const OPEN = 'open';

const treatmentStatuses = {
  CLOSED,
  OPEN,
};

export default treatmentStatuses;
